import { render, staticRenderFns } from "./SZ_homePage.vue?vue&type=template&id=832914a0&scoped=true"
import script from "./SZ_homePage.vue?vue&type=script&lang=js"
export * from "./SZ_homePage.vue?vue&type=script&lang=js"
import style0 from "./SZ_homePage.vue?vue&type=style&index=0&id=832914a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_a4zsohyuhqikhy5b53ajagp3li/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832914a0",
  null
  
)

export default component.exports